import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import { updateAppState,updateComponentState } from '../actions/actions';
import {AutoSelect} from './utils/utilcomponents';
import Loadingcontainer from './loadingcontainer';
import showToaster from './toaster';

class CreateServiceCallManual extends Component {
constructor(props) {
	super(props);
	this.state = {
		loaderflag : true,
		pageInfo : null,
		showPageInfo : false
	};

	this.onLoad = this.onLoad.bind(this);
	this.createServiceCall = this.createServiceCall.bind(this);
	this.inputOnChange = this.inputOnChange.bind(this);
}

componentWillMount() {
	this.onLoad();
}

onLoad = () => {
	this.updateLoaderFlag(false);
	if(!this.props.app.showManualCallCreation) this.props.history.push('/dashboard');
}

updateLoaderFlag(loaderflag) {
	this.setState({loaderflag});
}

createServiceCall(){
	this.updateLoaderFlag(true);

	let tempData = {
		data : {...this.state}
	};
	axios({
		method : 'post',
		data : tempData,
		url : '/api/createservicecallmanual'
	}).then((response)=> {
		if(response.data.status != 'success'){
			showToaster('failure', response.data.error[0]);
		}else{
			let pageInfo = {
				status : response.data.status
			};
			this.setState({pageInfo,showPageInfo : true});
		}
		setTimeout(() => {this.updateLoaderFlag(false)}, 0);
	});
}

inputOnChange(field, value) {
	this.setState({
		field : value
	});
}

render() {
	let { problem_description, contact_no, contact_name, showPageInfo, pageInfo } = this.state;
	
	let buttondisabled = true;
	if(problem_description && contact_no && contact_name) buttondisabled = false;

	return (
		<div>
			<div className="row">
				<Loadingcontainer isloading={this.state.loaderflag}></Loadingcontainer>
				<div className="col-md-6 offset-md-3 mt-2">
					{
						(!showPageInfo && !this.state.loaderflag) ?
							<div className="card borderradius-0 gs-card">
							<h6 className="card-header borderradius-0 card-header-custom gs-card-header text-center text-dark">Create Repair Call</h6>
							<div className="card-body">
								<div className="row">
									<div className="col-md-3 form-group">
										<label className="labelclass">ME Number</label>
									</div>
									<div className="col-md-9 form-group">
										<AutoSelect placeholder={"Select Equipment"} className={`${(!this.state.menumber) ? 'errorinput' : ''}`} resource="equipmentmenosearch" resourceName="equipments" fields="id,zzzmenumber,displayname" valuename="zzzmenumber" label="zzzmenumber" value={this.state.menumber} onChange={(value, valueobj) => {this.setState({menumber:value,zzzmenumber:value,mename:valueobj.displayname,department:valueobj.zzzdepartment,hospital:valueobj.partnerid_displayname})}} required={true} />
									</div>
								</div>
								<div className="row">
									<div className="col-md-3 form-group">
										<label className="labelclass">ME Name</label>
									</div>
									<div className="col-md-9 form-group">
										<input type="text" className="form-control" value = {this.state.mename} disabled/>
									</div>
								</div>
								<div className="row">
									<div className="col-md-3 form-group">
										<label className="labelclass">Department</label>
									</div>
									<div className="col-md-9 form-group">
										<input type="text" className="form-control" value = {this.state.department} disabled/>
									</div>
								</div>
								<div className="row">
									<div className="col-md-3 form-group">
										<label className="labelclass">Hospital</label>
									</div>
									<div className="col-md-9 form-group">
										<input type="text" className="form-control" value = {this.state.hospital} disabled/>
									</div>
								</div>
								<div className="row">
									<div className="col-md-3 form-group"><label className="labelclass">Problem Description</label></div>
									<div className="col-md-9 form-group">
										<textarea rows="5" className={`form-control ${!this.state.problem_description ? 'errorinput' : ''}`} value = {this.state.problem_description} onChange={(evt)=>{this.setState({'problem_description' : evt.target.value})}} required/>
									</div>
								</div>
								<div className="row">
									<div className="col-md-3 form-group"><label className="labelclass">Contact No</label></div>
									<div className="col-md-9 form-group">
										<input type ="text" className={`form-control ${!this.state.contact_no ? 'errorinput' : ''}`} value = {this.state.contact_no} onChange={(evt)=>{this.setState({'contact_no': evt.target.value})}} required/>
									</div>
								</div>
								<div className="row">
									<div className="col-md-3 form-group"><label className="labelclass">Contact Name</label></div>
									<div className="col-md-9 form-group">
										<input type="text" className={`form-control ${!this.state.contact_name ? 'errorinput' : ''}`} value = {this.state.contact_name} onChange={(evt)=>{this.setState({'contact_name' : evt.target.value})}} required/>
									</div>
								</div>
								<div className="row">
									<div className="col-md-12 form-group text-center">
										<button type="button" className="btn btn-sm btn-success btn-width" onClick={this.createServiceCall} disabled={buttondisabled}>Create</button>
									</div>
								</div>
							</div>
						</div>
						: null
					}
					{
						(showPageInfo && !this.state.loaderflag) ?
							<div className="card borderradius-0 gs-card">
								<div className="card-body">
									<div className="row">
										<div className="col-md-12 form-group">
											<div className={`alert ${pageInfo.status == 'success' ? 'alert-success border-success' : 'alert-info border-info'}  text-center`}>
												<div className="flex flex-wrap items-center ml-8">
													<div className="paragraph p-100 text-neutral-n600 flex-1">{(pageInfo.status == 'failure' ? pageInfo.error : 'Service request has been created successfully.')}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						: null
					}
				</div>
			</div>
		</div>
	);
}
}

CreateServiceCallManual = connect(
(state, props) => {
	let formName = 'createservicecallmanual';

	return {
		app : state.app,
		form : formName,
		componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
	}
}, { updateAppState,updateComponentState }
)(reduxForm()(CreateServiceCallManual));

export default CreateServiceCallManual;


// WEBPACK FOOTER //
// ./public/react/components/createservicecallmanual.js